module.exports = __webpack_public_path__ + "img/Check.adcaf8f9.svg";